import { createBlankEvent } from "@shared/models/analytics/base"
import type { PlanbookEditBasics } from "@shared/models/analytics/planbook"
import { getPossessiveForPlanbook } from "@shared/models/analytics/planbook"
import Patch from "@shared/models/patch-updater"
import type { Narrative } from "../create-narrative"
import defaultPlanbookActivity from "./default-planbook-activity"
import defaultPlanbookContext from "./default-planbook-context"
import defaultPlanbookModels from "./default-planbook-models"

export const PLANBOOK_CHANGE_TITLE = {
  name: "PLANBOOK_CHANGE_TITLE",
  params: {
    planbookId: "string",
    title: "string",
    originalTitle: "string",
  },

  patches(payload) {
    let patch = Patch.create("planbook", payload.planbookId).set(
      "attributes.title",
      payload.title
    ).patch

    return [patch]
  },

  undoPatches(payload) {
    let patch = Patch.create("planbook", payload.planbookId).set(
      "attributes.title",
      payload.originalTitle
    ).patch

    return [patch]
  },

  narrative(payload, findFn, userId): Narrative {
    let models = defaultPlanbookModels(payload, findFn, userId, payload.planbookId)

    let newTitle = payload.title
    let originalTitle = payload.originalTitle
    let newEvent: PlanbookEditBasics = {
      ...createBlankEvent(),
      root_id: payload.planbookId,
      root_type: "planbook",
      primary_object_id_and_ancestor_ids: [payload.planbookId],
      primary_object_type: "planbook",
      primary_possessive: getPossessiveForPlanbook(findFn, userId, payload.planbookId),
      primary_verb: "edit",
      primary_object_specifier: "title",
    }

    return {
      title: "Renamed Planbook",
      titleForAnalytics: "Planbook - Rename",
      description: `Changed the title from ${originalTitle} to ${newTitle}`,
      context: defaultPlanbookContext(payload, models),
      activity: defaultPlanbookActivity(payload, models),
      newAnalyticsEvents: [newEvent],
    }
  },
}

export default PLANBOOK_CHANGE_TITLE
